import React from 'react';
import { BadgeCheck } from 'lucide-react';

/**
 * VerifiedBadge — small blue check next to an official BrainSync
 * account's display name. Rendered only when the backend explicitly
 * marks the profile as `is_verified: true` (see
 * `RESERVED_USERNAME_ALLOWLIST` in /app/backend/routes/profiles.py).
 *
 * Sizing is controlled via a Tailwind `size` prop so callers can drop
 * it inline next to a big H1 or a small handle without extra wrapping.
 */
export const VerifiedBadge = ({ size = 'md', className = '' }) => {
    const px = size === 'sm' ? 'w-4 h-4' : size === 'lg' ? 'w-7 h-7' : 'w-5 h-5';
    return (
        <span
            title="Verified · Official BrainSync account"
            aria-label="Verified: Official BrainSync account"
            data-testid="verified-badge"
            className={`inline-flex items-center align-middle text-[#1D9BF0] ${className}`}
        >
            <BadgeCheck className={`${px} fill-[#1D9BF0] text-white`} strokeWidth={2.5} />
        </span>
    );
};

export default VerifiedBadge;
